/**
 * Returns a new string with the first letter capitalized.
 */
export const capitalizeFirstLetter = (
  str: string | null | undefined,
  locale = 'da-DK',
) => {
  if (!str) return '';

  const first = str?.at(0)?.toLocaleUpperCase(locale);
  const rest = str.slice(1);

  return first + rest;
};

export const removeSearchParams = (url: string | null | undefined) => {
  const urlWithoutSearchParams = url?.split('?').at(0);
  return urlWithoutSearchParams || url;
};

/**
 * Extracts the filename from a Content-Disposition header.
 * Handles both RFC 2183 (filename=) and RFC 2231 (filename*=) formats.
 * @param contentDisposition - The Content-Disposition header value
 * @returns The extracted filename, or null if not found
 */
export const extractFilenameFromContentDisposition = (
  contentDisposition: string | null | undefined,
): string | null => {
  if (!contentDisposition) return null;

  // Try RFC 2231 format first (filename*=UTF-8''encoded%20filename)
  const rfc2231Match = contentDisposition.match(
    /filename\*=(?:UTF-8'')?([^;]+)/,
  );
  if (rfc2231Match?.[1]) {
    try {
      return decodeURIComponent(rfc2231Match[1]);
    } catch {
      // Fall through to RFC 2183 if decoding fails
    }
  }

  // Try RFC 2183 format (filename="filename.ext" or filename=filename.ext)
  const rfc2183Match = contentDisposition.match(
    /filename=(?:"([^"]+)"|([^;]+))/,
  );
  if (rfc2183Match) {
    const filename = (rfc2183Match[1] ?? rfc2183Match[2])?.trim();
    return filename ?? null;
  }

  return null;
};
